import Vue from 'vue'
import Router from 'vue-router'
import Home from '../Pages/Home.vue'
import About from '../Pages/AboutUs.vue'
import Clients from '../Pages/Clients.vue'
import Job from '../Pages/Job.vue'
import Contact from '../Pages/Contact.vue'
Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
    if (savedPosition) {
      savedPosition.x = 0
      savedPosition.y = 0
      return savedPosition
    } else {
      const position = {}
  
      if (to.hash) {
        position.selector = to.hash
  
        if (document.querySelector(to.hash)) {
          return position
        }
  
        return false
      }
  
      return { x: 0, y: 0 }
    }
  }
 
export default new Router({
    mode: 'history',
    scrollBehavior,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home 
        },
        {
            path: '/conocenos',
            name: 'conocenos',
            component: About
        },
        {
            path: '/clientes',
            name: 'clientes',
            component: Clients 
        },
        {
            path: '/bolsa-de-trabajo',
            name: 'bolsatrabajo',
            component: Job
        },
        {
            path: '/contacto',
            name: 'contacto',
            component: Contact 
        }
    ]   
})